import { jsx as _jsx } from "react/jsx-runtime";
import { Button, LL_V_L, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_PathwayState } from '../../../../../../_entity.js';
import './Renderer_PathwayStates.scss';
import { guardResolutionAccordionUnsaved } from '../resolution-accordion-guard.js';
export const Renderer_PathwayStates = (props) => {
    const states = ModuleFE_PathwayState.cache.filter(s => s.pathwayIds.includes(props.pathwayId));
    return _jsx(TS_CollapsableContainerV2, { className: 'pathway-states', headerRenderer: () => `${states.length} States`, containerRenderer: () => _jsx(LL_V_L, { children: states.map(state => {
                return _jsx(Button, { variant: 'text', onClick: async () => {
                        if (!(await guardResolutionAccordionUnsaved(props.tabId)))
                            return;
                        props.workHubItem.updateArgs(props.tabId, { stateId: state._id, transitionId: undefined });
                    }, children: state.name }, state._id);
            }) }), animated: true, forceUpdate: true });
};
//# sourceMappingURL=Renderer_PathwayStates.js.map